import { createSlice } from '@reduxjs/toolkit';
import { SubscriptionType } from '@business/entities/subscription/subscription';
import type { RootState } from './store';

const initialState: SubscriptionType | null = null;

export const subscriptionStateSlice = createSlice({
  name: 'subscriptionStateSlice',
  initialState,
  reducers: {
    setSubscriptionData: (state, action) => {
      state = { ...action.payload };
      return state;
    },
    resetSubscriptionData: () => {
      return initialState;
    }
  }
});

export const { setSubscriptionData, resetSubscriptionData } =
  subscriptionStateSlice.actions;
export const getSubscriptionData = (state: RootState) =>
  state.subscriptionStateSlice;
